/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/12/9
 * @updateTime 2021/12/9
 * @decription 保全详情 =》执行信息
 */
// 预览模块
import ccPreviewModule from '@/components/common/preview-module/index.vue';
// 数据转换
import transformData from '@/views/mixins/transform-data.js';
// 请求js
import request from '../mixins/request.js';
export default {
    name: 'app-preview-bq-zxxx',
    // 混入
    mixins: [transformData, request],
    // 依赖组件
    components: {
        ccPreviewModule
    },
    // 注入
    inject: ['bqid'],
    // 参数
    props: {},
    // 数据
    data() {
        return {
            // 私有变量
            scope: {
                // class前缀
                prefixCls: 'fd-preview-bq-zxxx'
            },
            // 首保数据
            sbData: [],
            // 首保裁定书
            sbcdsData: [],
            // 续保数据
            xbData: [],
            // 续保裁定书
            xbcdsData: [],
            // 解保数据
            jbData: [],
            // 解保裁定书
            jbcdsData: []
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 创建完成
        this.init();
    },
    // 组件激活
    activated() {
        // 激活完成
    },
    // 组件初始化完成
    mounted() {
        // 初始化完成
    },
    // 组件失去激活
    deactivated() {
        // 失去激活
    },
    // 销毁之前
    beforeDestroy() {
        // 销毁之前
    },
    // 方法
    methods: {

        /**
         * 格式化首保数据
         * @param {Array<Object>} data 首保源数据
         * @returns {void}
         * */
        transformSbData(data) {
            const _transformItemDatas = [];
            data.length && data.forEach(dataItem => {
                const _transformItemData = [];
                _transformItemData.push(this.getRowData('执保案号', dataItem.cAjah));
                _transformItemData.push(this.getRowData('财产类型', dataItem.cCclxms));
                _transformItemData.push(this.getRowData('保全措施', dataItem.cZxcsms));
                _transformItemData.push(this.getRowData('保全开始日期', dataItem.dZxksrq));
                _transformItemData.push(this.getRowData('保全结束日期', dataItem.dZxjsrq));
                // 执行裁定书
                if (dataItem.sbcds && dataItem.sbcds.length) {
                    _transformItemData.push(this.getRowData('执行裁定书', dataItem.sbcds, true));
                }
                _transformItemDatas.push(_transformItemData);
            })
            // 首保数据赋值
            this.sbData = _transformItemDatas;
        },

        /**
         * 格式化续保数据
         * @param {Array<Object>} data 首保源数据
         * @returns {void}
         * */
        transformXbData(data) {
            const _transformItemDatas = [];
            data.length && data.forEach(dataItem => {
                const _transformItemData = [];
                _transformItemData.push(this.getRowData('执保案号', dataItem.cAjah));
                _transformItemData.push(this.getRowData('财产类型', dataItem.cCclxms));
                _transformItemData.push(this.getRowData('保全措施', dataItem.cZxcsms));
                _transformItemData.push(this.getRowData('续保开始日期', dataItem.dCdxbrq));
                _transformItemData.push(this.getRowData('续保结束日期', dataItem.dXbjmrq));
                _transformItemDatas.push(_transformItemData);
            })
            // 首保数据赋值
            this.xbData = _transformItemDatas;
        },

        /**
         * 格式化解保数据
         * @param {Array<Object>} data 首保源数据
         * @returns {void}
         * */
        transformJbData(data) {
            const _transformItemDatas = [];
            data.length && data.forEach(dataItem => {
                const _transformItemData = [];
                _transformItemData.push(this.getRowData('执保案号', dataItem.cAjah));
                _transformItemData.push(this.getRowData('财产类型', dataItem.cCclxms));
                _transformItemData.push(this.getRowData('保全措施', dataItem.cZxcsms));
                _transformItemData.push(this.getRowData('解保日期', dataItem.dJbrq));
                _transformItemDatas.push(_transformItemData);
            })
            // 首保数据赋值
            this.jbData = _transformItemDatas;
        },

        /**
         * 初始化数据
         * */
        initData() {
            this.requestBqzrx(this.bqid).then(res => {
                // 接口数据
                const _data = res.data;
                // 首保
                if (_data.sb) {
                    // 处理首保数据
                    this.transformSbData(_data.sb);
                    // 首保裁定书
                    this.sbcdsData = _data.sbcds;
                }
                // 续保
                if (_data.xb) {
                    // 处理续保数据
                    this.transformXbData(_data.xb);
                    // 续保裁定书
                    this.xbcdsData = _data.xbcds;
                }
                // 解保
                if (_data.jb) {
                    // 处理解保数据
                    this.transformJbData(_data.jb);
                    // 解保裁定书
                    this.jbcdsData = _data.jbcds;
                }
            }).catch(err => {
                console.log(err);
            });
        },

        /**
         * 初始化方法
         * @returns {void}
         * */
        init() {
            // 初始化数据
            this.initData();
        }
    }
};
